import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Translate } from 'react-redux-i18n';

import { uploadUsers, getCsvUsersModel } from '../app/store/actions/users';
import UploadFilesComponent from '../components/upload';
import UserImportErrors from '../components/upload/UserImportErrors';
import { history } from '../routers/AppRouter';
import ROUTES from '../data/routes';

class UploadUsersPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: [],
    };
  }

  sendFile = async (file) => {
    await this.setState({ errors: {} });
    const result = await this.props.uploadUsers(file);
    await this.setState({ errors: (result && result.errors) || [] });
  }

  modelDownload = async () => {
    await this.props.getCsvUsersModel();
  }

  goBack = () => {
    history.push(ROUTES.USERS);
  }

  render() {
    const { errors } = this.state;

    return (
      <div className="main-div-tables">
        <div className="main-table">
          <h2><Translate value="importUser" /></h2>

          <div className="upload-text">
            <p><strong><Translate value="uploadUserText1" /></strong></p>
            <p><Translate value="uploadUserText2" /></p>
            <p><Translate value="uploadUserText3" /></p>
            <p><Translate value="uploadUserText4" /></p>
            <p><Translate value="uploadUserText5" /></p>
            <p><Translate value="uploadUserText6" /></p>
            <p><Translate value="uploadUserText7" /></p>
            <p><Translate value="uploadUserText8" /></p>
            <p>
              <Translate value="uploadUserText9" />
              <strong>email</strong>
              <Translate value="uploadUserText10" />
              <strong>clientId</strong>
              <Translate value="uploadUserText11" />
              <strong>password</strong>
              <Translate value="uploadUserText14" />
              <strong>role</strong>
              <Translate value="uploadUserText15" />
              <strong>contracts</strong>
              <Translate value="uploadUserText12" />
              <strong>cartPermission</strong>
              <Translate value="uploadUserText16" />
              <strong>cartUserPermission</strong>
              <Translate value="uploadUserText17" />
              <strong>purchasePermission</strong>
              <Translate value="uploadUserText18" />
              <strong>purchaseCreditPermission</strong>
              <Translate value="uploadUserText19" />
              <strong>purchaseDebitPermission</strong>
              <Translate value="uploadUserText20" />
              <strong>purchaseBankSlipPermission</strong>
              <Translate value="uploadUserText21" />
              <strong>purchaseBillingPermission</strong>
              <Translate value="uploadUserText22" />
              <strong>purchaseEstimatePermission</strong>
              <Translate value="uploadUserText23" />
              <strong>similarityPermission</strong>
              <Translate value="uploadUserText24" />
              <strong>panelPermission</strong>
              <Translate value="uploadUserText25" />
              <strong>stockPermission</strong>
              <Translate value="uploadUserText26" />
              <strong>leadTimePermission</strong>
              <Translate value="uploadUserText27" />
              <strong>crossSellingPermission</strong>
              <Translate value="uploadUserText28" />
              <strong>pricePermission</strong>
              <Translate value="uploadUserText29" />
              <strong>clientCodePermission</strong>
              <Translate value="uploadUserText30" />
              <strong>spherePermission</strong>
              <Translate value="uploadUserText31" />
              <strong>emailPermission</strong>
              <Translate value="uploadUserText32" />
              <strong>spotPermission</strong>
              <Translate value="uploadUserText33" />
              <strong>opicCodePermission</strong>
              <Translate value="uploadUserText34" />
              <strong>soneparCodePermission</strong>
              <Translate value="uploadUserText35" />
              <strong>visualizeAllOrdersPermission</strong>
              <Translate value="uploadUserText36" />
            </p>
          </div>

          <UploadFilesComponent
            sendFile={this.sendFile}
            goBack={this.goBack}
            modelDownload={this.modelDownload}
            itemsErrors={<UserImportErrors errors={errors} />}
          />
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  uploadUsers: file => dispatch(uploadUsers(file)),
  getCsvUsersModel: () => dispatch(getCsvUsersModel()),
});

export default connect(null, mapDispatchToProps)(UploadUsersPage);
